import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
//const countryId =localStorage.getItem("country_Id");

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllCollectionTypeDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllCollectionType`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };

// export const AllCollectionTypeDetails = async () => {
//   const cacheKey = "allCollectionTypeDetails";
//   const cacheExpiryKey = "allCollectionTypeDetailsExpiry";
//   const cacheExpiryTime = 10 * 60 * 1000; // 10 minutes in milliseconds

//   // Retrieve the cached data and its expiry time
//   const cachedData = sessionStorage.getItem(cacheKey);
//   const cachedExpiryTime = sessionStorage.getItem(cacheExpiryKey);

//   // Check if the cached data exists and is still valid
//   if (cachedData && cachedExpiryTime) {
//     const now = new Date().getTime();

//     if (now < parseInt(cachedExpiryTime)) {
//       return JSON.parse(cachedData); // Return the cached data if valid
//     } else {
//       // Remove the cached data if expired
//       sessionStorage.removeItem(cacheKey);
//       sessionStorage.removeItem(cacheExpiryKey);
//     }
//   }

//   try {
//     // If there's no valid cached data, make the API call
//     const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllCollectionType`, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`
//       }
//     });

//     // Store the data in session storage along with the current timestamp
//     sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
//     sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };


export const CreateCollectionTypeDetails = async (collectionTypeData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddNewCollectionType`, collectionTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };
